<template>
  <section>
    <h3>Video Ask Test</h3>
    <iframe
      src="https://www.videoask.com/fe8z1qlr9"
      allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
      width="100%"
      height="600px"
      style="border: none; border-radius: 24px"
    >
    </iframe>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

